import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

// Gate for the partner-scoped SEO settings router. The URL is warehouse-less, so the per-warehouse
// `rt_ipp_seo` Roulette toggle can't be evaluated here; enablement is expressed via the
// `seo_self_serve` entitlement instead (mirrors storefront content-pages, which gates its
// partner-scoped route on `featureEntitlementIds`). The picker only tier-filters the site list.
export const seoRetailerAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.SeoView],
  featureEntitlementIds: [FeatureEntitlements.SeoSelfServe],
}

// The strict, all-axes SEO gate, evaluated against a single warehouse: `seo.view` permission, the
// `rt_ipp_seo` Roulette toggle, and the `seo_self_serve` entitlement — all must pass. Used by
// `SeoSiteAccessGate` to re-check the site chosen in the partner-scoped picker, since that route's own
// gate is warehouse-less and can't evaluate the per-warehouse toggle.
export const seoRetailerScopedAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.SeoView],
  warehouseFeatureToggles: [FeatureToggle.SeoEnabled],
  featureEntitlementIds: [FeatureEntitlements.SeoSelfServe],
}
